/**
 * Single source of truth for every Zoho CRM organization variable this
 * extension owns. Import from here — never spell a variable name inline.
 */

export const EXTENSION_IDENTIFIER = process.env.REACT_APP_EXTENSION_IDENTIFIER;

/** Suffixes of the extension's org variables (Zoho prefixes them with the identifier). */
export const ORG_VARS = {
  API_KEY: "API_KEY",
  ORGANIZATION_ID: "Organization_ID",
  ZAPI_KEY: "ZAPI_Key",
  DATA_CENTER_URL: "Data_Center_URL",
  DB_CONNECTION_URL: "DB_Connection_URL",
};

/** Full Zoho API name of an org variable, e.g. `easymysqlsync__API_KEY`. */
export const orgVarName = (suffix) => `${EXTENSION_IDENTIFIER}__${suffix}`;

/** Full names of all org variables, keyed like ORG_VARS. */
export const ORG_VAR_NAMES = Object.fromEntries(
  Object.entries(ORG_VARS).map(([key, suffix]) => [key, orgVarName(suffix)])
);
